import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

// token 除了 cookie 之外，再鏡射一份到 sessionStorage。
//
// 為什麼：官網把 /guest 整頁嵌成 iframe。只要外層不是 chiuchau.com
// （zeabur.app 預覽網域、手機從內網 IP 看），iframe 就是「第三方」情境，
// 瀏覽器對第三方 cookie 一律封鎖或分割（Safari 全擋、Chrome 分割且需
// Partitioned 屬性），js-cookie 寫進去等於沒寫，下一頁一讀是空的 → 直接
// 被導去登入表單。實測從 127.0.0.1 的測試頁嵌 dev-air 就是這樣。
//
// 但這個 app 的 API 驗證全部走 `Authorization: Bearer` 標頭（57 個檔案都經由
// getToken()），cookie 只是「存放處」，後端從來不靠它。所以存放處多一個
// sessionStorage 就夠了：第三方 iframe 裡的 sessionStorage 各家瀏覽器都
// 給（按最上層網站分割，但同一個 iframe 生命週期內讀寫一致），而且分頁
// 關掉就清，正好符合訪客 session 的壽命。
//
// 安全面沒有變差：token cookie 本來就不是 httpOnly，同源 JS 一直讀得到；
// 正常登入照舊寫 cookie（跨子網域共享），sessionStorage 只是鏡射。
const TOKEN_STORAGE_KEY = "token";

const storage = {
	get() {
		try {
			return window.sessionStorage.getItem(TOKEN_STORAGE_KEY) || undefined;
		} catch {
			return undefined; // 私密視窗 / storage 被停用
		}
	},
	set(token) {
		try {
			window.sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
		} catch {
			/* 忽略 */
		}
	},
	remove() {
		try {
			window.sessionStorage.removeItem(TOKEN_STORAGE_KEY);
		} catch {
			/* 忽略 */
		}
	},
};

export const getToken = () => {
	// cookie 優先（正常登入、跨子網域共享）；被第三方情境擋掉時退到 sessionStorage
	return Cookies.get("token") || storage.get();
};

export const decodeToken = () => {
	try {
		const token = getToken();
		if (!token) return null;
		return jwtDecode(token);
	} catch (error) {
		return null;
	}
};

/**
 * 是否為訪客模式（免登入示範連結換發的 token）。
 * 僅用於切換 UI；實際權限一律由後端護欄決定，前端判斷不具安全意義。
 */
export const isGuestUser = () => {
	return decodeToken()?.guest === true;
};

export function setTokenCookie(token) {
	const opts = {
		path: "/",
		secure: window.location.protocol === "https:",
		sameSite: "Lax",
	};
	if (window.location.hostname.endsWith("chiuchau.com")) {
		opts.domain = ".chiuchau.com";
	}
	Cookies.set("token", token, opts);
	storage.set(token);
}

export function removeTokenCookie() {
	const opts = { path: "/" };
	if (window.location.hostname.endsWith("chiuchau.com")) {
		opts.domain = ".chiuchau.com";
	}
	Cookies.remove("token", opts);
	storage.remove();
}
